/**
 * api.js — Centralised API client for the Sales Marketing Chatbot.
 * All fetch calls to the FastAPI backend go through this module.
 */

const BASE_URL =  process.env.REACT_APP_API_BASE_URL;

/* ------------------------------------------------------------------
   Helpers
------------------------------------------------------------------ */

async function handleResponse(res) {
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`API ${res.status}: ${text}`);
  }
  return res.json();
}

/* ------------------------------------------------------------------
   API client
------------------------------------------------------------------ */

export const chatApi = {
  /** Send a chat message and get the agent response. */
  async sendMessage(payload) {
    const res = await fetch(`${BASE_URL}/chatbot/chat/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    return handleResponse(res);
  },

  /** Submit 👍 / 👎 feedback for a specific message. */
  async submitFeedback(payload) {
    const res = await fetch(`${BASE_URL}/chatbot/feedback/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    await handleResponse(res);
  },

  /** Get recent search history for the sidebar. */
  async getHistory(limit = 50) {
    const res = await fetch(
      `${BASE_URL}/chatbot/history?limit=${limit}`
    );
    return handleResponse(res);
  },

  /** Clear session cache (called on New Chat). */
  async clearSession(sessionId = null) {
    const res = await fetch(
      `${BASE_URL}/chatbot/session/clear/`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          session_id: sessionId,
        }),
      }
    );

    await handleResponse(res);
  },

  /** Basic health check. */
  async health() {
    try {
      const res = await fetch(`${BASE_URL}/chatbot/health`);
      const data = await res.json();
      return data?.status === 'ok';
    } catch {
      return false;
    }
  },
};